export const CONNECTION_ISSUES = "It seems that you have connection issues, please try again"